import { DataTransferService } from 'src/app/shared/services/common/datatransfer.service';
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/pages/common/api.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-card-switch',
  templateUrl: './card-switch.component.html',
  styleUrls: ['./card-switch.component.scss'],
  providers: [ApiService]
})
export class CardSwitchComponent implements OnInit {
  userCards = [];
  selectedCardId;
  constructor(
    public _apiService: ApiService,
    public _bsModalRef: BsModalRef,
    private toastr: ToastrService,
    private dataTransferService: DataTransferService
  ) {
    this.getCards();
  }

  ngOnInit(): void {
    if (localStorage.getItem('userCard')) {
      this.selectedCardId = JSON.parse(localStorage.getItem('userCard')).id;
    }
  }

  getCards() {
    var userCards = JSON.parse(localStorage.getItem("userCards"));
    if(userCards && userCards.length > 0){
      this.userCards = userCards;
    }
    else{
      this._apiService.getCards().subscribe((res) => {
        console.log('switch')
        if (res && res.data) {
          this.userCards = res.data;
          if(this.userCards.length > 1){
            this.dataTransferService.nextUserCards(res.data);
          } else {
            this.dataTransferService.nextUserCards([res.data]);
          }
          // localStorage.setItem("userCards", JSON.stringify(this.userCards));
        }
      }, (err) => {
        this.toastr.error('An error occured while fetching the cards! Please try again.');
        setTimeout(()=>{
            this._bsModalRef.hide();
        }, 3000);
      })
    }
  }

  setCard(each) {
    this._apiService.validateCard(each.attributes.bin, each.attributes.bin_type).subscribe(res => {
      if (res && res.data && res.data.attributes.bin == each.attributes.bin && (res.data.attributes.status == 'bin_verified' || res.data.attributes.status == 'payment_verified')) {
        let current_user = JSON.parse(localStorage.getItem("currentUser"));
        // current_user.token = res.data.attributes.session_token;
        // localStorage.setItem('currentUser', JSON.stringify(current_user));
        localStorage.setItem('card_verified', "true");
        localStorage.setItem('userCard', JSON.stringify(res.data));
        window.location.href = "/";
      }
      else {
        localStorage.setItem('card_verified', "false");
      }
    })
  }
}
